import { CurveModal } from './CurveModal';

export default CurveModal;
